<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="780px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    fullscreen
    @closed="handleClosed"
  >
    <el-form
      ref="ruleForm"
      class="edit-user-form"
      style="max-width: 1100px;margin: 0 auto;"
      :model="info"
      :rules="rules"
      label-width="100px">
      <el-form-item
        label="账号："
        prop="account">
        <span v-if="type ===1 || info.staffId">{{ info.account }}</span>
        <el-input
          v-else
          v-model="info.account"></el-input>
      </el-form-item>
      <el-form-item
        label="姓名："
        prop="staffName">
        <span v-if="type ===1">{{ info.staffName }}</span>
        <el-input
          v-else
          v-model="info.staffName"></el-input>
      </el-form-item>
      <el-form-item
        v-if="userInfo.userType === 506"
        label="业务范围："
        prop="servicePermmisions">
        <service-select v-model="info.servicePermmisions" />
      </el-form-item>
      <el-form-item
        label="功能："
        prop="functions">
        <checkbox-tree
          v-model="info.functions"
          :treeData="menuNodes"
          nodeKey="funcId"
          :defaultProps="defaultProps"
          :operations="info.operations"
          @reset="reset"
          @change="change" />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">
        取 消
      </el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import ServiceSelect from './service-select.vue'
import CheckboxTree from './checkbox-tree.vue'
import { guid } from '@/utils/index'
import { mapState } from 'vuex'
export default {
  name: 'EditUserModal',
  components: { ServiceSelect, CheckboxTree },
  props: {
    callback: { type: Function }
  },
  data() {
    return {
      loading: false,
      visible: false,
      type: -1,
      info: { staffId: null, account: '', staffName: '', userType: '', mobile: '', servicePermmisions: [], functions: [], operations: {}},
      menuNodes: [],
      defaultProps: { children: 'children', label: 'menuName' },
      rules: {
        account: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        staffName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        servicePermmisions: [
          { required: false, message: '请选择业务范围', trigger: 'change' }
        ],
        functions: [
          { required: true, message: '请选择功能', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo
    }),
    title() {
      const staffId = this.info.staffId
      return (staffId ? '编辑' : '新增') + '账号'
    }
  },
  methods: {
    reset() {
      this.info.operations = {}
    },
    change(e) {
      this.info.operations = e
    },
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      console.log('handleClosed')
      this.menuNodes = []
      this.info = { ...this.info, ...this.$options.data().info }
      // this.info.functions = []
      // this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const { staffId, account, staffName, servicePermmisions, functions, userType, mobile, operations, orgId } = this.info
          const dispatch = this.info.staffId ? 'updatestaff' : 'addstaff'
          this.$store.dispatch(`account/${dispatch}`, {
            payload: {
              staffId,
              account,
              staffName,
              userType: userType || this.userInfo.userType,
              password: '123456',
              mobile,
              orgId,
              servicePermmisions: servicePermmisions.map(item => ({ serviceId: item })),
              functions: functions.filter(item => typeof item === 'number').map(item => ({
                funcId: item,
                operations: operations[item].map(s => ({ operation: s }))
              }))
            },
            success: () => {
              this.loading = false
              this.toggleModal(false)
              this.$message.success('操作成功')
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    getportalmenutree2orgtype() {
      this.loading = true
      this.$store.dispatch('account/getorgportalmenutree', {
        payload: { orgType: 100 },
        success: res => {
          this.loading = false
          res.data.menuNodes.forEach(item => {
            item.funcId = item.funcId || `custom-${guid()}`
            if (!this.info.operations[item.funcId]) {
              this.$set(this.info.operations, item.funcId, [])
            }
            (item.children || []).forEach(s => {
              s.funcId = s.funcId || `custom-${guid()}`
              if (!this.info.operations[s.funcId]) {
                this.$set(this.info.operations, s.funcId, [])
              }
              (s.children || []).forEach(m => {
                m.funcId = m.funcId || `custom-${guid()}`
                if (!this.info.operations[m.funcId]) {
                  this.$set(this.info.operations, m.funcId, [])
                }
              })
            })
          })
          this.$set(this, 'menuNodes', res.data.menuNodes)
          // this.menuNodes = res.data.menuNodes
          // .map(i => {
          //   // const disabled = this.info.isAdmin === 1
          //   // i.disabled = disabled
          //   if (!this.info.operations[i.funcId]) {
          //     this.info.operations[i.funcId] = {
          //       operation: []
          //     }
          //   }
          //   i.operations = i.operations || []
          //   i.children = i.children ? i.children.map(s => {
          //     // s.disabled = disabled
          //     if (!this.info.operations[s.funcId]) {
          //       this.info.operations[s.funcId] = {
          //         operation: []
          //       }
          //     }
          //     s.operations = s.operations || []
          //     return s
          //   }) : []
          //   return i
          // })
        },
        fail: () => {
          this.loading = false
          this.menuNodes = []
        }
      })
    },
    add(options = {}, type) {
      this.type = type
      this.info = {
        ...this.info,
        account: options.mobilePhone,
        staffName: options.name,
        mobile: options.wxMobilePhone,
        ...options,
        orgId: this.userInfo.orgId
      }
      this.getportalmenutree2orgtype()
      this.toggleModal(true)
    },
    update(options = {}) {
      this.info = { ...this.info, ...options }
      this.getportalmenutree2orgtype()
      this.toggleModal(true)
    }
  }
}
</script>
<style lang="stylus" scoped>
.edit-user-form {
  /deep/.el-tree-node__content {
    height: auto !important;
  }
}
</style>
